import axios from "../axios/index.js";

const urlGetRoom = "/api/get-room";
const urlGetProductTrending = "/api/get-product-trending";
const urlGetGallery = "api/get-gallery";
const urlGetListMyWishList = "api/get-list-my-wishlist";
const urlGetListSearch = "api/get-list-search";

export default {
    getRoom(params) {
        return axios.post(urlGetRoom, params);
    },

    getGallery(){
        return axios.post(urlGetGallery);
    },

    getProductTrending(params) {
        return axios.post(urlGetProductTrending, params);
    },

    getListMyWishList(params) {
        return axios.post(urlGetListMyWishList, params);
    },

    getListSearch(params) {
        return axios.post(urlGetListSearch, params);
    }
};
